import { useQuery } from "hooks/useQuery";
import { getAvailableBrokers } from "features/Dashboard/service";
import { BLOCKED_BROKERS } from "utils/constants";

export const useSupportedBrokers = () => {
  const { isLoading, data } = useQuery({
    key: "supportedBrokers",
    queryKey: ["supportedBrokers"],
    queryFn: async () => {
      const data = await getAvailableBrokers();
      const brokers = Array.isArray(data) ? data : [];
      return brokers.filter(
        (broker) => !BLOCKED_BROKERS.includes(broker?.slug)
      );
    },
  });

  return {
    isLoading,
    brokers: data || [],
  };
};
